// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"207":"101fce8e","453":"a8526ae0"}[chunkId] + ".chunk.js";
};